/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, extendObservable } from 'mobx';
import { createResourceStoreHouse } from 'src/luis/core/stores/resourceStoreHouse';
import { ResourceStoreHouse } from 'src/luis/types/stores/core/ResourceStoreHouse';
import { IntentStore } from 'src/luis/types/stores/intents/IntentStore';
import { IntentStoreHouse } from 'src/luis/types/stores/intents/IntentStoreHouse';
import { SubtractStore } from 'src/luis/types/SubtractStore';

/**
 * A factory function for creating an intent store house,
 * which houses an array of intent stores.
 */
export const createIntentStoreHouse = (): IntentStoreHouse => {
    const resourcesStoreHouse = createResourceStoreHouse<IntentStore>();

    const intentStoreHouse: SubtractStore<IntentStoreHouse, ResourceStoreHouse<IntentStore>> = {
        /**
         * Finds an intent by the given name and returns undefined
         * if not found.
         *
         * @param name The name to search with.
         * @returns The intent or undefined if not found.
         */
        findByName(name: string): IntentStore {
            return this.items.find(i => i.name === name);
        }
    };

    return extendObservable(resourcesStoreHouse, intentStoreHouse, { findByName: action }, { deep: false });
};
